import { useRecoilValue } from "recoil";
import OfficeAppliancesBrandTable from "./view";
import { PERMISSIONS } from "modules/PermissionsConstants";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";

const OfficeAppliancesBrand = () => {
  const viewPermission = PERMISSIONS.permission_officeappliancebrand_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) && (
        <OfficeAppliancesBrandTable />
      )}
    </>
  );
};

export default OfficeAppliancesBrand;
